<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-card-title>
          Update Admin User:&ensp;{{ myAdminUser.firstName }}
          {{ myAdminUser.lastName }}</v-card-title
        >
        <v-card-text>
          <h5>
            Current perimeters:&ensp;<b>{{ myAdminUser.adminPerimeter }} </b>
          </h5>
          <v-form>
            <v-select
              v-model="perimeter"
              :items="refCountries"
              label="Perimeter"
              item-text="label"
              item-value="code"
              multiple
              chips
              hint="What are the target perimeter(s)"
              persistent-hint
              required
            ></v-select>
            <v-divider></v-divider>
            <v-btn color="success" class="mr-4" @click="update">
              Validate
            </v-btn>
            <v-btn color="warning" @click="back()" class="mr-4">
              Return
            </v-btn>
            <v-btn color="error" class="mr-4" @click="deleteDialog()">
              delete
            </v-btn>
          </v-form>
        </v-card-text>
        <v-snackbar
          v-model="snackbar"
          :color="snackBarColor"
          :timeout="snackBarTimeout"
        >
          <b>{{ snackBarText }} </b>
        </v-snackbar>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-text>
            <v-container>
              <span>
                Are you sure you want to delete the administrator
                <p style="font-weight: bold;">
                  {{ myAdminUser.firstName }} {{ myAdminUser.lastName }}
                </p></span
              >
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false"
              >No</v-btn
            >
            <v-btn color="red darken-1" text @click="deleteAdmin()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<style></style>

<script>
export default {
  name: "AddAdminUser",
  data() {
    return {
      myAdminUser: {},
      adminPerimeters: [],
      role: "ROLE_ADMIN",
      perimeter: [],
      refCountries: [],
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
      dialog: false,
    };
  },
  mounted: function() {
    this.loadData();
    this.fillCountries();
  },
  methods: {
    slectedItems: function() {
      if (this.myAdminUser.adminPerimeter == "all") {
        this.perimeter = [];
      } else {
        let listOfPerimeters = this.myAdminUser.adminPerimeter.split(",");
        this.perimeter = listOfPerimeters;
      }
    },
    fillCountries: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/countries", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refCountries = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    loadData: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/useradmin/" +
          this.$route.params.id,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          }
        })
        .then((json) => {
          this.myAdminUser = json.data;
          this.slectedItems();
        });
    },
    update: function() {
      this.savePerimeters();
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/updateadmin?id=" +
          this.$route.params.id +
          "&name=" +
          this.role +
          "&perimeter=" +
          this.adminPerimeters,
        {
          method: "POST",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json.status == "200") {
            this.snackbar = true;
            this.snackBarText = "User Successfully Updated";
            this.snackBarColor = "succes";
          } else {
            this.snackbar = true;
            this.snackBarText = "Failed update user";
            this.snackBarColor = "error";
          }
          this.loadData();
        });
      this.clearPerimeters();
    },
    delete: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/deleteadmin?id=" +
          this.myAdminUser.id,
        {
          method: "DELETE",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json.status == "200") {
            this.snackbar = true;
            this.snackBarText = "user successfully deleted";
            this.snackBarColor = "succes";
          } else {
            this.snackbar = true;
            this.snackBarText = "failed to delete admin";
            this.snackBarColor = "error";
          }
          this.back();
        });
    },
    getColor: function() {
      if (this.error) {
        return "red darken-2";
      } else {
        return "green darken-2";
      }
    },
    back() {
      this.$router.back();
    },
    deleteAdmin() {
      this.delete();
    },
    deleteDialog() {
      this.dialog = true;
    },
    savePerimeters: function() {
      if (this.perimeter.length == 0) {
        this.adminPerimeters.push("all");
      } else {
        for (let index = 0; index < this.perimeter.length; index++) {
          this.adminPerimeters.push(this.perimeter[index]);
        }
      }
    },
    clearPerimeters: function() {
      this.adminPerimeters = [];
    },
  },
};
</script>
